module.exports = __webpack_public_path__ + "img/实验室资源管理.2b471232.jpg";